export default {
  GET_EQUIPMENT_TYPES: '@INIT/GET_EQUIPMENT_TYPES',
  GET_EQUIPMENT_TYPES_SUCCESS: '@INIT/GET_EQUIPMENT_TYPES_SUCCESS',
  GET_EQUIPMENT_TYPES_FAILURE: '@INIT/GET_EQUIPMENT_TYPES_FAILURE',

  GET_TIMEZONE: '@INIT/GET_TIMEZONE',
  GET_TIMEZONE_SUCCESS: '@INIT/GET_TIMEZONE_SUCCESS',
  GET_TIMEZONE_FAILURE: '@INIT/GET_TIMEZONE_FAILURE',

  GET_HOT_OFFERS: '@INIT/GET_HOT_OFFERS',
  GET_HOT_OFFERS_SUCCESS: '@INIT/GET_HOT_OFFERS_SUCCESS',
  HOT_OFFERS_SEEN: '@INIT/HOT_OFFERS_SEEN',

  GET_OFFERS: '@INIT/GET_OFFERS',
  GET_OFFERS_SUCCESS: '@INIT/GET_OFFERS_SUCCESS',

  GET_AVATAR: '@INIT/GET_AVATAR',
  GET_AVATAR_SUCCESS: '@INIT/GET_AVATAR_SUCCESS'
}
